<template>
	<div class="content body_height">
		<div class="userbox">
			<div class="userle">
				<router-link v-for="(item,index) in userListArr " :key="index" class="tabdiv" :to="'/'+item.to">
					<span>
						{{item.text}}
						<!-- <i :class="item.icon"></i>{{item.text}} -->
					</span>
				</router-link>
				<div class="tabdiv cur_brand" @click="exit">
					<span>
						退出登录
					</span>
				</div>
			</div>
			<div class="userri">
				<router-view></router-view>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'usercenter',
		components: {

		},
		data() {
			return {
				listIndex: 0,
				userListArr: [{
						to: 'mywork',
						icon: 'el-icon-apple',
						text: '我的作品'
					},
					// {
					// 	to: 'worklist',
					// 	icon: 'el-icon-apple',
					// 	text: '作品著作权'
					// }, 
					// {
					// 	to: 'myorder',
					// 	icon: 'el-icon-apple',
					// 	text: '我的订单'
					// },
					{
						to: 'mycollect',
						icon: 'el-icon-apple',
						text: '我的收藏'
					},
					{
						to: 'mylike',
						icon: 'el-icon-apple',
						text: '我的点赞'
					},
					// {
					// 	to: 'mynews',
					// 	icon: 'el-icon-apple',
					// 	text: '我的消息'
					// },
					{
						to: 'editdata',
						icon: 'el-icon-apple',
						text: '修改资料'
					},
					{
						to: 'accountsafety',
						icon: 'el-icon-apple',
						text: '账号安全'
					}
				]
			}
		},
		created() {},
		updated() {},
		methods: {
		
			//退出登录
			exit() {
				localStorage.clear()
				this.$store.commit('changeAppUser', null)
				this.$msg.success('已退出！')
				this.$router.push({
					name:'home'
				})
			},
		}
	}
</script>
<style lang="scss" scoped>
	.active {
		color: var(--brand);
	}

	.userbox {
		display: flex;
		align-items: flex-start;
		margin-top: 20px;

		.userle {
			background-color: var(--white);
			border-radius: 10px;
			padding: 14px 20px;
			width: 180px;
			margin-right: 20px;

			.tabdiv {
				color: var(--black);

				span {
					cursor: pointer;
					line-height: 54px;
					font-size: 16px;
					display: block;
					margin-left:10px;

				}

				&:hover {
					color: var(--brand);
				}

				& i {
					font-size: 18px;
					margin-right: 4px;
				}

				&.router-link-active {
					color: var(--brand);
				}
			}


		}

		.userri {
			flex: 1;
		}
	}
</style>
